export class Memebership {
  id: number = 0;
  name: string = '';
  description: string = '';
  benefits?: string[];
}
